import { getTemplates } from '../../services/journal/templates.service'

// MF-67 — Journal templates list slice.
export const UPDATE_JOURNAL_TEMPLATES_LIST = 'UPDATE_JOURNAL_TEMPLATES_LIST'
export const TOGGLE_JOURNAL_TEMPLATES_LOADING = 'TOGGLE_JOURNAL_TEMPLATES_LOADING'
export const JOURNAL_TEMPLATES_ERROR = 'JOURNAL_TEMPLATES_ERROR'
export const JOURNAL_TEMPLATES_UPDATE_TOTAL = 'JOURNAL_TEMPLATES_UPDATE_TOTAL'

export const updateTemplatesList = (value = []) => ({
  type: UPDATE_JOURNAL_TEMPLATES_LIST,
  payload: { value }
})

export const templatesError = (value = null) => ({
  type: JOURNAL_TEMPLATES_ERROR,
  payload: { value }
})

export const toggleLoadingTemplates = (value = false) => ({
  type: TOGGLE_JOURNAL_TEMPLATES_LOADING,
  payload: { value }
})

export const updateTotalTemplates = (value = 0) => ({
  type: JOURNAL_TEMPLATES_UPDATE_TOTAL,
  payload: { value }
})

export const loadTemplates = (params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingTemplates(true))
      dispatch(templatesError())

      const { data } = await getTemplates(params)

      dispatch(updateTemplatesList(data?.paginatedResults ?? []))
      dispatch(updateTotalTemplates(data?.totalRecords ?? 0))
    } catch (error) {
      dispatch(updateTemplatesList([]))
      dispatch(updateTotalTemplates(0))
      dispatch(templatesError(error?.message ?? 'error'))
    } finally {
      dispatch(toggleLoadingTemplates(false))
    }
  }
}
